import "./VideoCarousel.css";
import React from "react";
import {Carousel} from 'react-bootstrap';
import ReactPlayer from "react-player";
import "bootstrap/dist/css/bootstrap.css"
import { useTranslation } from 'react-i18next';

const VideoCarousel =() => {
    const { t } = useTranslation();
const videoProperties = [
    {
        id: 1,
        title: "Video 1",
        src: "https://www.youtube.com/watch?v=o8j-Vwo37E8&ab_channel=LaVidadelosSantos",
        credit: "",
    },
    {
        id: 2,
        title: "Video 2",
        src: "https://www.youtube.com/watch?v=dVZIN3Bmklg&ab_channel=SocietyofSt.VincentdePaul",
        credit: "",
    },
    {
        id: 3,
        title: "Video 3",
        src: "https://www.youtube.com/watch?v=O14t6Y8_zH8&ab_channel=SocietyofSt.VincentdePaul",
        credit: "",
    },

]

    return <div className="App">
            <div class='title-top-content'>{t('home.recentActivities')}</div>
        <Carousel>
            {videoProperties.map((videoObj)=>{
                return(
                    <Carousel.Item key={videoObj.id}>
                        <ReactPlayer
                            url={videoObj.src}
                            width="100%"
                            height="500px"
                            pip={true}
                            controls={true}
                            playing={false}
                        />
                    <Carousel.Caption>
                        <h3>{videoObj.title}</h3>
                        <p>{videoObj.credit}</p>
                    </Carousel.Caption>
                    </Carousel.Item>

                )
            })}
        </Carousel>
    </div>
}

export default VideoCarousel;
